import { render, staticRenderFns } from "./TotalInfo.vue?vue&type=template&id=088a8824&scoped=true&"
import script from "./TotalInfo.vue?vue&type=script&lang=js&"
export * from "./TotalInfo.vue?vue&type=script&lang=js&"
import style0 from "./TotalInfo.vue?vue&type=style&index=0&id=088a8824&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088a8824",
  null
  
)

export default component.exports